<template>
  <div class="insurance-services" :class="{ bg_gray: conf }">
    <div class="insurance-services__ttl-wrapper container">
      <h2 class="insurance-services__ttl f-24 bold wc-lg uppercase">
        {{ main_title }}
      </h2>
    </div>
    <div
      class="insurance-services__inner"
      :class="{ container: windowWidth >= 768 }"
    >
      <swiper :options="swiperOptions">
        <swiper-slide :key="index" v-for="(service, index) in content">
          <div class="insurance-services__img-wrapper br-12 wc-lg">
            <img
              :src="service.image[0].url"
              :alt="
                $route.name == 'PageViewRouter_ge'
                  ? service.seo_keywords_ge
                  : service.seo_keywords_en
              "
            />
          </div>
          <div class="insurance-services__service-ttl-wrapper flex a_center">
            <svg
              id="Group_5_Copy_3"
              data-name="Group 5 Copy 3"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
            >
              <path
                id="Combined_Shape_Copy_2"
                data-name="Combined Shape Copy 2"
                d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                fill="#000"
              />
            </svg>

            <a target="_blank" :href="service.url"
              ><h2 class="bold f-18 wc-lg uppercase">
                {{ service.title }}
              </h2></a
            >
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="insurance-services__scrollbar flex j_sb container">
      <div class="insurance-services__scrollbar--line"></div>
      <div class="insurance-services__navigation flex">
        <div class="insurance-services__prev pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_2500"
              data-name="Group 2500"
              transform="translate(-13 -12.801)"
            >
              <g
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                transform="translate(13 12.801)"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175.342a1.167,1.167,0,0,0,0,1.65l3.842,3.842H1.166a1.167,1.167,0,0,0,0,2.334h8.85L6.175,12.008a1.167,1.167,0,1,0,1.65,1.65l5.834-5.833.02-.021.01-.01.01-.01.012-.013.007-.008.013-.015.005-.006.014-.017,0-.005.014-.018,0,0,.013-.018,0,0,.013-.018,0-.006.012-.018,0-.007.01-.016.005-.009.008-.014.007-.012.006-.011.009-.016,0-.007.011-.021v0a1.166,1.166,0,0,0-.24-1.359L7.825.342a1.167,1.167,0,0,0-1.65,0Z"
                  transform="translate(14 14) rotate(180)"
                  fill="#7063e9"
                />
              </g>
            </g>
          </svg>
        </div>

        <div class="insurance-services__next pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g
              id="Group_2499"
              data-name="Group 2499"
              transform="translate(-13 -12.801)"
            >
              <g
                id="Group_5_Copy_3"
                data-name="Group 5 Copy 3"
                transform="translate(13 12.801)"
              >
                <path
                  id="Combined_Shape_Copy_2"
                  data-name="Combined Shape Copy 2"
                  d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z"
                  fill="#7063e9"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resize_handler from "@/mixins/resize_handler";
export default {
  props: ["contentData"],
  mixins: [resize_handler],
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        grabCursor: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        speed: 800,
        watchOverflow: true,
        scrollbar: {
          el: ".insurance-services__scrollbar--line",
          draggable: true,
          hide: false,
          dragSize: 350,
          snapOnRelease: false
        },
        navigation: {
          nextEl: ".insurance-services__next",
          prevEl: ".insurance-services__prev"
        },
        breakpoints: {
          1023: {
            spaceBetween: 30,
            slidesPerView: 3
          },
          767: {
            spaceBetween: 10,
            slidesPerView: 1.5,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            scrollbar: {
              dragSize: 137
            }
          }
        },

        pagination: {}
      }
    };
  },
  computed: {
    main_title() {
      return _.get(this.contentData, "conf.header.title");
    },
    content() {
      return _.get(this.contentData, "data.list");
    },
    conf() {
      return _.get(this.contentData, "conf.conf[0]");
    }
  },
  mounted() {}
};
</script>
